import { useInitLanguage } from '../../hooks/use-init-language';
import { LocalizationProviderProps } from './localization-provider.props';

export const LocalizationProvider = ({ children }: LocalizationProviderProps) => {
	useInitLanguage();

	return <>{children}</>;
};
